import React, { useState } from 'react';
import { X } from 'lucide-react';
import { MessageModal } from './MessageModal';
interface AskQuestionModalProps {
  isOpen: boolean;
  onClose: () => void;
  listingTitle: string;
}
export function AskQuestionModal({
  isOpen,
  onClose,
  listingTitle
}: AskQuestionModalProps) {
  const [question, setQuestion] = useState('');
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (question.trim().length < 10) {
      alert('Question must be at least 10 characters');
      return;
    }
    setIsMessageModalOpen(true);
    setTimeout(() => {
      onClose();
      setQuestion('');
    }, 2000);
  };
  return <>
      <div data-testid="ask-question-modal-overlay" className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-430">
        <div data-testid="ask-question-modal" className="bg-white border border-gray-300 max-w-lg w-full shadow-lg" data-id="element-431">
          <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-432">
            <h3 data-testid="ask-question-modal-title" className="font-bold text-lg" data-id="element-433">
              Ask a Question
            </h3>
            <button data-testid="ask-question-modal-close-btn" onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-434">
              <X className="w-5 h-5" data-id="element-435" />
            </button>
          </div>

          <form data-testid="ask-question-form" onSubmit={handleSubmit} className="p-6 space-y-4" data-id="element-436">
            <div data-testid="ask-question-listing-info" className="p-3 bg-gray-50 border border-gray-200" data-id="element-437">
              <p className="text-sm text-gray-600" data-id="element-438">About:</p>
              <p data-testid="ask-question-listing-title" className="font-bold" data-id="element-439">
                {listingTitle}
              </p>
            </div>

            <div data-id="element-440">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-441">
                Your Question
              </label>
              <textarea data-testid="ask-question-text-input" value={question} onChange={e => setQuestion(e.target.value)} placeholder="Ask about documentation, location, pricing, or any other details..." rows={5} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500 text-sm" data-id="element-442" />
              <p data-testid="ask-question-char-count" className="text-xs text-gray-500 mt-1" data-id="element-443">
                Minimum 10 characters ({question.length}/10)
              </p>
            </div>

            <div className="p-3 bg-yellow-50 border border-yellow-200 text-xs text-yellow-900" data-id="element-444">
              <p className="font-bold mb-1" data-id="element-445">Note:</p>
              <p data-id="element-446">
                Your question will be public and visible to all users. The
                seller will be notified and typically responds within 24 hours.
              </p>
            </div>

            <div className="flex justify-end gap-3 pt-4" data-id="element-447">
              <button data-testid="ask-question-cancel-btn" type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-448">
                Cancel
              </button>
              <button data-testid="ask-question-submit-btn" type="submit" className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-449">
                Submit Question
              </button>
            </div>
          </form>
        </div>
      </div>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Question Submitted" message="Your question has been sent to the seller. You'll be notified when they respond." type="success" data-id="element-450" />
    </>;
}